/**
 * User Store Module
 */


// Types
import * as types from '@/lib/store/types'

const DEFAULT_USER = {
	AccountId: "1401",
	EventId: "2650",
	Salutation: "Mr",
	Firstname: 'Sean',
	Middlename: "P",
	Lastname: 'Maloney',
	Email: 'smaloney@getsynchronicity.com',
	Phone1: '867-5309',
	Title: 'Area Manager',
	Company: 'GetSynchronicity',
	Division: '',
	Address1: '',
	Address2: '',
	City: '',
	State: '',
	Zip: '',
	Country: '',
	TelCountryCode: '',
	Phone1: '',
	URL: '',
	Friendly: 'Surface01'	
}

// State
const state = {
	user: DEFAULT_USER,
}

const actions = {
	[types.LOGIN_USER]({ commit }, params) {
		commit(types.SET_USER, params)
	},

	[types.LOGOUT_USER]({ commit }) {
		commit(types.UNSET_USER)
	},
}

const mutations = {
	[types.SET_USER](state, data) {
		state.user = data
	},

	[types.UNSET_USER](state) {
		window.close()
		state.user = DEFAULT_USER
	},
}

const getters = {
	user: state => state.user
}

export default {
	state,
	actions,
	mutations,
	getters,
}



// WEBPACK FOOTER //
// ./src/lib/store/modules/User.js